import React from 'react';
import { Icon } from 'elements';

const Twitter = ({size, className}) => (
  <Icon size={size} className={className}>
    <path d="M24,4.559c-0.883,0.391-1.831,0.657-2.827,0.775c1.017-0.609,1.795-1.575,2.164-2.722
      c-0.954,0.564-2.007,0.973-3.128,1.195c-0.898-0.958-2.176-1.555-3.593-1.555c-2.719,0-4.924,2.205-4.924,4.922
      c0,0.385,0.043,0.762,0.127,1.122C7.728,8.091,4.1,6.131,1.672,3.152C1.248,3.878,1.006,4.724,1.006,5.627
      c0,1.708,0.87,3.215,2.19,4.097C2.389,9.697,1.63,9.475,0.966,9.106v0.061c0,2.385,1.698,4.375,3.949,4.828
      c-0.412,0.111-0.847,0.172-1.297,0.172c-0.318,0-0.625-0.031-0.927-0.091c0.627,1.957,2.445,3.38,4.598,3.419
      C5.604,18.815,3.481,19.6,1.174,19.6c-0.397,0-0.789-0.024-1.174-0.067c2.179,1.399,4.766,2.215,7.547,2.215
      c9.057,0,14.007-7.502,14.007-14.007l-0.017-0.637C22.505,6.413,23.342,5.546,24,4.559z"/>
  </Icon>
);

export default Twitter;



// WEBPACK FOOTER //
// ./src/core/icons/components/social/Twitter.jsx